import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'hammerjs';

import { AppComponent } from './app.component';
import { AppService } from './app.service';

import { PdfBuilderService } from './shared/pdfBuilder.service';

import { LockerRenderComponent } from './components/locker-render/locker-render.component';
import { ConfigListComponent } from './components/config-list/config-list.component';
import { OrderFormComponent } from './components/order-form/order-form.component';
import { DropdownSectionComponent } from './components/dropdown-section/dropdown-section.component';
import { SizeLegendComponent } from './components/size-legend/size-legend.component';

import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import {NgSelectModule} from '@ng-select/ng-select';


import { TranslatorModule } from 'angular-translator';

@NgModule({
	declarations: [
		AppComponent,
		LockerRenderComponent,
		ConfigListComponent,
		OrderFormComponent,
		DropdownSectionComponent,
		SizeLegendComponent
	],
	imports: [
		BrowserModule,
		FormsModule,
		HttpModule,
		BrowserAnimationsModule,
    AngularMultiSelectModule,
    NgSelectModule,
    TranslatorModule.forRoot({
      providedLanguages: ['es', 'ca', 'en', 'fr', 'ru', 'ar' ],
      defaultLanguage: (window.location.search.slice(1).length>0)?window.location.search.slice(1):'es',
      detectLanguage: false,
      loaderOptions: {
        path: 'assets/localization/{{language}}-lang.json'
      }
    })
	],
	providers: [AppService, PdfBuilderService],
	bootstrap: [AppComponent]
})
export class AppModule { }
